module.exports = __webpack_public_path__ + "img/reaction16.0678315d.png";